
import { CustomFieldParams } from '@/types/customFieldTypes';
import { File } from '../file';
import { CustomField } from './customField';

export class FileCustomField extends CustomField {
  file?: File;

  constructor(data: CustomFieldParams) {
    super(data);
    this.file = data.file ? new File(data.file) : undefined;
  }

  hasValidDefaultInput() { return true; }

  hasValidCustomInput() { return true; }

  getUpdatedAt() {
    if (this.file && this.updatedAt && this.file.updatedAt && this.file.updatedAt > this.updatedAt) return this.file.updatedAt;
    return this.updatedAt;
  }

  asString() {
    return this.file?.fileName || super.asString();
  }

  isEmpty() {
    return this.file === undefined;
  }

  getValue() {
    return this.file?.s3Url;
  }
}
